import { Component, inject, OnInit, signal } from '@angular/core';
import { ScreenService } from '../../core/screen/screen.service';
import { UserService } from '../../core/user/user.service';
import { SubpageBaseComponent } from '../component-base/subpage-base.component';
import { Router, RouterLink } from '@angular/router';
import { AppPage } from '../component-base/app-page.component';
import { AccountHeaderComponent } from '../account-header/account-header.component';
import { MatDivider, MatListItem, MatListItemMeta, MatListItemTitle, MatNavList } from '@angular/material/list';
import { MatIcon } from '@angular/material/icon';
import { CustomerDataService } from '../../ladeloesung/shared/customer-data.service';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss'],
  standalone: true,
  imports: [
    AccountHeaderComponent,
    MatNavList,
    MatDivider,
    MatListItem,
    RouterLink,
    MatListItemTitle,
    MatListItemMeta,
    MatIcon,
  ],
})
@AppPage({
  useAppFullWidth: true,
})
export class AccountComponent extends SubpageBaseComponent implements OnInit {
  readonly screen = inject(ScreenService);
  private readonly userService = inject(UserService);

  private readonly customerDataService = inject(CustomerDataService);

  protected readonly userEmail = signal<string>('')
  protected readonly customerNumber = signal<string>('');
  protected readonly isLadeloesung = signal<boolean>(false);

  constructor() {
    const router = inject(Router);

    super(router);
  }

  ngOnInit(): void {
    this.userEmail.set(this.userService.email ?? '');
    this.isLadeloesung.set(this.userService.getTargetApp() === 'ladeloesung');
    this.userService.getUserInfo().subscribe(() => {
      this.userEmail.set(this.userService.email ?? '');
      this.isLadeloesung.set(this.userService.getTargetApp() === 'ladeloesung');
    });

    this.customerDataService.read().subscribe((customerData) => {
      this.customerNumber.set(customerData?.customerNumber ?? '');
    });
  }

  protected logout(): void {
    this.userService.logout();
  }
}
